import { render, staticRenderFns } from "./InvPT.vue?vue&type=template&id=7efcfdae&scoped=true"
import script from "./InvPT.vue?vue&type=script&lang=js"
export * from "./InvPT.vue?vue&type=script&lang=js"
import style0 from "./_layout.css?vue&type=style&index=0&id=7efcfdae&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efcfdae",
  null
  
)

export default component.exports